// Jest Snapshot v1, https://goo.gl/fbAQLP

exports[`renders and matches snapshot 1`] = `
Object {
  "asFragment": [Function],
  "baseElement": <body>
    <div>
      <div
        class="MuiGrid-root MuiGrid-item MuiGrid-grid-xs-12"
      >
        <div
          class="MuiSnackbar-root MuiSnackbar-anchorOriginTopCenter"
        >
          <div
            class="MuiPaper-root MuiAlert-root MuiAlert-filledError makeStyles-root-1 MuiPaper-elevation0"
            direction="down"
            role="alert"
            style="opacity: 1; transform: scale(1, 1); transition: opacity 225ms cubic-bezier(0.4, 0, 0.2, 1) 0ms,transform 150ms cubic-bezier(0.4, 0, 0.2, 1) 0ms;"
          >
            <div
              class="MuiAlert-icon"
            >
              <svg
                aria-hidden="true"
                class="MuiSvgIcon-root MuiSvgIcon-fontSizeInherit"
                focusable="false"
                viewBox="0 0 24 24"
              >
                <path
                  d="M11 15h2v2h-2zm0-8h2v6h-2zm.99-5C6.47 2 2 6.48 2 12s4.47 10 9.99 10C17.52 22 22 17.52 22 12S17.52 2 11.99 2zM12 20c-4.42 0-8-3.58-8-8s3.58-8 8-8 8 3.58 8 8-3.58 8-8 8z"
                />
              </svg>
            </div>
            <div
              class="MuiAlert-message"
            />
            <div
              class="MuiAlert-action"
            >
              <button
                aria-label="Close"
                class="MuiButtonBase-root MuiIconButton-root MuiIconButton-colorInherit MuiIconButton-sizeSmall"
                tabindex="0"
                title="Close"
                type="button"
              >
                <span
                  class="MuiIconButton-label"
                >
                  <svg
                    aria-hidden="true"
                    class="MuiSvgIcon-root MuiSvgIcon-fontSizeSmall"
                    focusable="false"
                    viewBox="0 0 24 24"
                  >
                    <path
                      d="M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z"
                    />
                  </svg>
                </span>
                <span
                  class="MuiTouchRipple-root"
                />
              </button>
            </div>
          </div>
        </div>
        
      </div>
      <div
        class="MuiContainer-root MuiContainer-disableGutters MuiContainer-maxWidthSm"
      >
        <div
          class="MuiBox-root MuiBox-root-3"
        >
          <h4
            class="MuiTypography-root MuiTypography-h4 MuiTypography-colorInherit"
          >
            General
          </h4>
        </div>
        <div
          class="MuiBox-root MuiBox-root-4"
        >
          <div
            class="MuiContainer-root MuiContainer-disableGutters MuiContainer-maxWidthSm"
          >
            <div
              class="MuiBox-root MuiBox-root-5"
            >
              <div
                class="MuiGrid-root MuiGrid-container MuiGrid-justify-xs-space-between"
              >
                <div
                  class="MuiBox-root MuiBox-root-6"
                >
                  <span
                    class="MuiTypography-root MuiTypography-body1"
                  >
                    Email
                  </span>
                </div>
                <div
                  class="MuiBox-root MuiBox-root-7"
                  style="cursor: pointer;"
                >
                  <svg
                    aria-hidden="true"
                    class="MuiSvgIcon-root MuiSvgIcon-fontSizeSmall"
                    focusable="false"
                    style="color: rgb(16, 128, 128);"
                    viewBox="0 0 24 24"
                  >
                    <path
                      d="M3 17.25V21h3.75L17.81 9.94l-3.75-3.75L3 17.25zM20.71 7.04c.39-.39.39-1.02 0-1.41l-2.34-2.34a.9959.9959 0 00-1.41 0l-1.83 1.83 3.75 3.75 1.83-1.83z"
                    />
                  </svg>
                  <span
                    class="MuiBox-root MuiBox-root-8"
                  >
                    <span
                      class="MuiTypography-root MuiTypography-body2"
                    >
                      Edit
                    </span>
                  </span>
                </div>
              </div>
            </div>
            <div
              class="MuiBox-root MuiBox-root-9"
            >
              <div
                class="MuiGrid-root MuiGrid-container"
              >
                <div
                  class="MuiBox-root MuiBox-root-10"
                >
                  <span
                    class="MuiTypography-root MuiTypography-body2"
                  >
                    user@dr-bill.ca
                  </span>
                </div>
              </div>
            </div>
          </div>
          <div
            class="MuiContainer-root MuiContainer-disableGutters MuiContainer-maxWidthSm"
          >
            <div
              class="MuiBox-root MuiBox-root-11"
            >
              <div
                class="MuiGrid-root MuiGrid-container MuiGrid-justify-xs-space-between"
              >
                <div
                  class="MuiBox-root MuiBox-root-12"
                >
                  <span
                    class="MuiTypography-root MuiTypography-body1"
                  >
                    Password
                  </span>
                </div>
                <div
                  class="MuiBox-root MuiBox-root-13"
                  style="cursor: pointer;"
                >
                  <svg
                    aria-hidden="true"
                    class="MuiSvgIcon-root MuiSvgIcon-fontSizeSmall"
                    focusable="false"
                    style="color: rgb(16, 128, 128);"
                    viewBox="0 0 24 24"
                  >
                    <path
                      d="M3 17.25V21h3.75L17.81 9.94l-3.75-3.75L3 17.25zM20.71 7.04c.39-.39.39-1.02 0-1.41l-2.34-2.34a.9959.9959 0 00-1.41 0l-1.83 1.83 3.75 3.75 1.83-1.83z"
                    />
                  </svg>
                  <span
                    class="MuiBox-root MuiBox-root-14"
                  >
                    <span
                      class="MuiTypography-root MuiTypography-body2"
                    >
                      Edit
                    </span>
                  </span>
                </div>
              </div>
            </div>
            <div
              class="MuiBox-root MuiBox-root-15"
            >
              <div
                class="MuiGrid-root MuiGrid-container"
              >
                <div
                  class="MuiBox-root MuiBox-root-16"
                >
                  <span
                    class="MuiTypography-root MuiTypography-body2"
                  >
                    ********
                  </span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </body>,
  "container": <div>
    <div
      class="MuiGrid-root MuiGrid-item MuiGrid-grid-xs-12"
    >
      <div
        class="MuiSnackbar-root MuiSnackbar-anchorOriginTopCenter"
      >
        <div
          class="MuiPaper-root MuiAlert-root MuiAlert-filledError makeStyles-root-1 MuiPaper-elevation0"
          direction="down"
          role="alert"
          style="opacity: 1; transform: scale(1, 1); transition: opacity 225ms cubic-bezier(0.4, 0, 0.2, 1) 0ms,transform 150ms cubic-bezier(0.4, 0, 0.2, 1) 0ms;"
        >
          <div
            class="MuiAlert-icon"
          >
            <svg
              aria-hidden="true"
              class="MuiSvgIcon-root MuiSvgIcon-fontSizeInherit"
              focusable="false"
              viewBox="0 0 24 24"
            >
              <path
                d="M11 15h2v2h-2zm0-8h2v6h-2zm.99-5C6.47 2 2 6.48 2 12s4.47 10 9.99 10C17.52 22 22 17.52 22 12S17.52 2 11.99 2zM12 20c-4.42 0-8-3.58-8-8s3.58-8 8-8 8 3.58 8 8-3.58 8-8 8z"
              />
            </svg>
          </div>
          <div
            class="MuiAlert-message"
          />
          <div
            class="MuiAlert-action"
          >
            <button
              aria-label="Close"
              class="MuiButtonBase-root MuiIconButton-root MuiIconButton-colorInherit MuiIconButton-sizeSmall"
              tabindex="0"
              title="Close"
              type="button"
            >
              <span
                class="MuiIconButton-label"
              >
                <svg
                  aria-hidden="true"
                  class="MuiSvgIcon-root MuiSvgIcon-fontSizeSmall"
                  focusable="false"
                  viewBox="0 0 24 24"
                >
                  <path
                    d="M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z"
                  />
                </svg>
              </span>
              <span
                class="MuiTouchRipple-root"
              />
            </button>
          </div>
        </div>
      </div>
      
    </div>
    <div
      class="MuiContainer-root MuiContainer-disableGutters MuiContainer-maxWidthSm"
    >
      <div
        class="MuiBox-root MuiBox-root-3"
      >
        <h4
          class="MuiTypography-root MuiTypography-h4 MuiTypography-colorInherit"
        >
          General
        </h4>
      </div>
      <div
        class="MuiBox-root MuiBox-root-4"
      >
        <div
          class="MuiContainer-root MuiContainer-disableGutters MuiContainer-maxWidthSm"
        >
          <div
            class="MuiBox-root MuiBox-root-5"
          >
            <div
              class="MuiGrid-root MuiGrid-container MuiGrid-justify-xs-space-between"
            >
              <div
                class="MuiBox-root MuiBox-root-6"
              >
                <span
                  class="MuiTypography-root MuiTypography-body1"
                >
                  Email
                </span>
              </div>
              <div
                class="MuiBox-root MuiBox-root-7"
                style="cursor: pointer;"
              >
                <svg
                  aria-hidden="true"
                  class="MuiSvgIcon-root MuiSvgIcon-fontSizeSmall"
                  focusable="false"
                  style="color: rgb(16, 128, 128);"
                  viewBox="0 0 24 24"
                >
                  <path
                    d="M3 17.25V21h3.75L17.81 9.94l-3.75-3.75L3 17.25zM20.71 7.04c.39-.39.39-1.02 0-1.41l-2.34-2.34a.9959.9959 0 00-1.41 0l-1.83 1.83 3.75 3.75 1.83-1.83z"
                  />
                </svg>
                <span
                  class="MuiBox-root MuiBox-root-8"
                >
                  <span
                    class="MuiTypography-root MuiTypography-body2"
                  >
                    Edit
                  </span>
                </span>
              </div>
            </div>
          </div>
          <div
            class="MuiBox-root MuiBox-root-9"
          >
            <div
              class="MuiGrid-root MuiGrid-container"
            >
              <div
                class="MuiBox-root MuiBox-root-10"
              >
                <span
                  class="MuiTypography-root MuiTypography-body2"
                >
                  user@dr-bill.ca
                </span>
              </div>
            </div>
          </div>
        </div>
        <div
          class="MuiContainer-root MuiContainer-disableGutters MuiContainer-maxWidthSm"
        >
          <div
            class="MuiBox-root MuiBox-root-11"
          >
            <div
              class="MuiGrid-root MuiGrid-container MuiGrid-justify-xs-space-between"
            >
              <div
                class="MuiBox-root MuiBox-root-12"
              >
                <span
                  class="MuiTypography-root MuiTypography-body1"
                >
                  Password
                </span>
              </div>
              <div
                class="MuiBox-root MuiBox-root-13"
                style="cursor: pointer;"
              >
                <svg
                  aria-hidden="true"
                  class="MuiSvgIcon-root MuiSvgIcon-fontSizeSmall"
                  focusable="false"
                  style="color: rgb(16, 128, 128);"
                  viewBox="0 0 24 24"
                >
                  <path
                    d="M3 17.25V21h3.75L17.81 9.94l-3.75-3.75L3 17.25zM20.71 7.04c.39-.39.39-1.02 0-1.41l-2.34-2.34a.9959.9959 0 00-1.41 0l-1.83 1.83 3.75 3.75 1.83-1.83z"
                  />
                </svg>
                <span
                  class="MuiBox-root MuiBox-root-14"
                >
                  <span
                    class="MuiTypography-root MuiTypography-body2"
                  >
                    Edit
                  </span>
                </span>
              </div>
            </div>
          </div>
          <div
            class="MuiBox-root MuiBox-root-15"
          >
            <div
              class="MuiGrid-root MuiGrid-container"
            >
              <div
                class="MuiBox-root MuiBox-root-16"
              >
                <span
                  class="MuiTypography-root MuiTypography-body2"
                >
                  ********
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>,
  "debug": [Function],
  "findAllByAltText": [Function],
  "findAllByDisplayValue": [Function],
  "findAllByLabelText": [Function],
  "findAllByPlaceholderText": [Function],
  "findAllByRole": [Function],
  "findAllByTestId": [Function],
  "findAllByText": [Function],
  "findAllByTitle": [Function],
  "findByAltText": [Function],
  "findByDisplayValue": [Function],
  "findByLabelText": [Function],
  "findByPlaceholderText": [Function],
  "findByRole": [Function],
  "findByTestId": [Function],
  "findByText": [Function],
  "findByTitle": [Function],
  "getAllByAltText": [Function],
  "getAllByDisplayValue": [Function],
  "getAllByLabelText": [Function],
  "getAllByPlaceholderText": [Function],
  "getAllByRole": [Function],
  "getAllByTestId": [Function],
  "getAllByText": [Function],
  "getAllByTitle": [Function],
  "getByAltText": [Function],
  "getByDisplayValue": [Function],
  "getByLabelText": [Function],
  "getByPlaceholderText": [Function],
  "getByRole": [Function],
  "getByTestId": [Function],
  "getByText": [Function],
  "getByTitle": [Function],
  "queryAllByAltText": [Function],
  "queryAllByDisplayValue": [Function],
  "queryAllByLabelText": [Function],
  "queryAllByPlaceholderText": [Function],
  "queryAllByRole": [Function],
  "queryAllByTestId": [Function],
  "queryAllByText": [Function],
  "queryAllByTitle": [Function],
  "queryByAltText": [Function],
  "queryByDisplayValue": [Function],
  "queryByLabelText": [Function],
  "queryByPlaceholderText": [Function],
  "queryByRole": [Function],
  "queryByTestId": [Function],
  "queryByText": [Function],
  "queryByTitle": [Function],
  "rerender": [Function],
  "unmount": [Function],
}
`;
